import { IMRadioGroup } from '@insurancemenu/imenu-components-lib';
import { ListStyled } from '@insurancemenu/imenu-components-lib/dist/components/RadioGroup/styles';
import {
  RadioLabelWrapperStyled,
  InputStyled,
} from '@insurancemenu/imenu-components-lib/dist/components/RadioButton/styles';
import styled from 'styled-components';

export const IMRadioGroupStyled = styled(IMRadioGroup)`
  & ${ListStyled} {
    gap: 4rem;
  }

  & ${RadioLabelWrapperStyled} {
    gap: 2rem;
  }

  & ${InputStyled} {
    margin-top: 1.6rem;
  }
`;
